export default {
  downtimeUrl: "https://it.kodland.tech",
  startPage: {
    title: "Prenota una lezione di programmazione o sviluppo di videogiochi per tuo figlio/a",
    subtitle:
      "Rispondi ad alcune semplici domande e troveremo un argomento che susciti l'interesse di tuo figlio/a 🔥",
    button: "Clicca qui per proseguire",
  },
  successPage: {
    title:
      "Perfetto! Vi chiediamo di scegliere un orario comodo per voi, per prenotare la vostra GRATUITA lezione🚀 <br /> Partecipa a una lezione individuale live per introdurre tuo figlio/a al mondo della creazione di videogiochi o coding 🔥",
    subtitle: 'Clicca su "📆 Prenota una lezione" per completare la registrazione',
    button: "📆 Prenota una lezione",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Vorresti che tuo figlio/a acquisisca una competenza professionale che possa essere dimostrata e utilizzata in futuro?",
      answers: ["🎉 Si!", "❌ No"],
    },
    2: {
      question: "Vorresti che il tempo che tuo figlio/a trascorre al computer sia più produttivo?",
      answers: ["💯 Sì!", "⌛️ No. È solo per divertimento va bene così"],
    },
    3: {
      question: "Quali sono le cose più importanti che vuoi ottenere da questa lezione?",
      answers: [
        "🎓 Trascorrere del tempo più produttivo, utilizzando la tecnologia",
        "🖥 Informazioni sulla nostra piattaforma di apprendimento",
        "🙌 Competenze utili per il futuro",
        "👶 Un'ora insieme per imparare qualcosa di nuovo",
        "👍 Un'esperienza amichevole e piacevole",
        "💪 Scoprire se a mio figlio/a possa piacere l'argomento",
      ],
    },
  },
};
